import { getAllPrimaryTopics } from "@/services/events/topics.service";

let icons = [];

export function setTopicIconsSVG() {
  let TOPICS = getAllPrimaryTopics();
  TOPICS.map((topic) => {
    let svgBlack, svgWhite, svgBlue, svgPlain;
    try {
      svgBlack = require(`@/assets/svgs/events_${topic.type}_black.svg`);
      svgWhite = require(`@/assets/svgs/events_${topic.type}_white.svg`);
      svgBlue = require(`@/assets/svgs/events_${topic.type}_blue.svg`);
      svgPlain = require(`@/assets/svgs/events_${topic.type}_plain.svg`);
    } catch (err) {
      // can't find the icon then use the default events icon
      svgBlack = require(`@/assets/svgs/events_black.svg`);
      svgWhite = require(`@/assets/svgs/events_white.svg`);
      svgBlue = require(`@/assets/svgs/events_blue.svg`);
      svgPlain = require(`@/assets/svgs/events_plain.svg`);
    }
    icons.push({
      Name: topic.type,
      Icons: {
        black: svgBlack,
        white: svgWhite,
        blue: svgBlue,
        plain: svgPlain,
      },
    });
  });
}

export const SVG_ICONS_TOPICS = icons;
